<template>
    <v-switch
        v-model       = "selected"
        class         = "step-site-down mt-0 pt-1 pb-1"
        :class        = "selected===true?'step-site-down-active':''"
        @change       = "onChange"
        :hide-details = "true"
        :readonly     = "readonly"
        :color        = "value?'error':'primary'"
        :ripple       = "false"

    >
        <template v-slot:label>
            <span :class="value===true?'step-site-down-active':''">Anlage steht</span>
        </template>
    </v-switch>
</template>

<script>
export default {
    name: "IncSiteDownSwitch",

    props: {
        value: {

        },

        readonly: {
            required: false,
            type: Boolean,
            default: function () {
                return false;
            }
        },
    },

    data: () => ({
        selected: null
    }),

    mounted() {
        this.selected = this.value;
    },

    watch: {
        value () {
            this.selected = this.value;
        }
    },

    methods: {
        onChange () {
            this.$emit('input',  this.selected);
        }
    }

}
</script>

<style scoped>

</style>